let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eCpgx")).then(() => parcelRequire('nYcpU'));